import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import App from "./client/App";
import "./styles/font.css";
import "react-loading-skeleton/dist/skeleton.css";

import "swiper/swiper-bundle.min.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
const appStart = async () => {
  console.log("앱 실행 완료");
};

Sentry.init({
  dsn: "https://feaab18a60414357bec22aa87c2cae0b@o4503975195574272.ingest.sentry.io/4505361449222144",
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById("root")
);
